import React, { useState } from 'react'

import {
    ContractDocument,
    RegionRf,
    ContractSupplierRowError,
} from '../../types'
import HoverTooltip from '../../../../../../../components/HoverTooltip'

import ContractSupplierEditPopup from '../ContractSupplierEditPopup'

import { ContractDoc, ContractSupplier, CountryList } from '../../../../types'

import { isSameContractSupplier, getContractSupplierRowKey } from '../../index'

type Props = {
    contractGuid: string | undefined
    index: number
    theme: string
    contractSupplier: ContractSupplier
    contractAction: boolean
    onDeleteSupplierRow: (rowKey: string) => void
    onPatch: (rowKey: string, patch: Partial<ContractSupplier>) => void
    oksmList: CountryList[]
    regionRfList: RegionRf[]
    errors?: ContractSupplierRowError
}

const ContractSuppliersTableRow: React.FC<Props> = (props) => {
    const [contractSupplierEditPopup, setContractSupplierEditPopup] =
        useState<boolean>(false)

    const handleContractSupplierEditPopup = () => {
        setContractSupplierEditPopup(!contractSupplierEditPopup)
    }

    const rowKey = getContractSupplierRowKey(props.contractSupplier)

    return (
        <div className="flex flex-col">
            {/* строка организации */}
            <div
                className={`plan-position-table-row flex flex-row gap-1 mx-1 rounded text-[11px] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] hover:bg-[#FFFFFF] dark:bg-[#2A282B] dark:hover:bg-[#373538] ${props.errors ? 'border border-[#C15C5C] py-1' : ''}`}
                onDoubleClick={() => {
                    if (props.contractAction == true) {
                        handleContractSupplierEditPopup()
                    }
                }}
            >
                <div className="flex w-[40px] min-h-[40px] items-center justify-center text-center ">
                    {props.index + 1}
                </div>
                <div className="flex flex-1 w-full items-center justify-center text-left">
                    {props.contractSupplier.supplier_short_name
                        ? props.contractSupplier.supplier_short_name
                        : '-'}
                </div>
                <div className="flex w-[120px] items-center justify-center text-center ">
                    {props.contractSupplier.supplier_inn
                        ? props.contractSupplier.supplier_inn
                        : '-'}
                </div>
                <div className="flex flex-1 w-full items-center justify-center text-left">
                    {`${props.contractSupplier.supplier_address_post_code ? props.contractSupplier.supplier_address_post_code + ', ' : ''}${props.contractSupplier.supplier_address_country_name ? props.contractSupplier.supplier_address_country_name + ', ' : ''}${props.contractSupplier.supplier_address_region_name ? props.contractSupplier.supplier_address_region_name + ', ' : ''}${props.contractSupplier.supplier_address_city ? props.contractSupplier.supplier_address_city + ', ' : ''}${props.contractSupplier.supplier_address_street ? props.contractSupplier.supplier_address_street + ', ' : ''}${props.contractSupplier.supplier_address_house ? props.contractSupplier.supplier_address_house + ', ' : ''}${props.contractSupplier.supplier_address_building ? props.contractSupplier.supplier_address_building + ', ' : ''}${props.contractSupplier.supplier_address_office ? props.contractSupplier.supplier_address_office : ''}`}
                </div>
                <div className="flex w-8 text-right items-center justify-center"></div>
                {props.contractAction ? (
                    <>
                        <div className="flex w-8 text-right items-center justify-center"></div>
                        <div className="flex w-8 text-right items-center justify-center">
                            <HoverTooltip tooltipText="Открыть">
                                <button
                                    className="w-6 h-6 grid rounded-full items-center justify-center hover:bg-[#FFFFFF] dark:hover:bg-[#656365]"
                                    onClick={() =>
                                        handleContractSupplierEditPopup()
                                    }
                                >
                                    <svg
                                        className="w-4 h-4"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        id="edit-alt"
                                    >
                                        <path
                                            fill={
                                                props.theme == 'dark'
                                                    ? '#FFFFFF'
                                                    : '#181818'
                                            }
                                            d="M3,8H21a1,1,0,0,0,0-2H3A1,1,0,0,0,3,8Zm18,8H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Zm0-5H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z"
                                        ></path>
                                    </svg>
                                </button>
                            </HoverTooltip>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="flex w-8 text-right items-center justify-center">
                            <HoverTooltip tooltipText="Редактировать">
                                <button
                                    className="w-6 h-6 grid rounded-full items-center justify-center hover:bg-[#FFFFFF] dark:hover:bg-[#656365]"
                                    onClick={() =>
                                        handleContractSupplierEditPopup()
                                    }
                                >
                                    <svg
                                        className="w-4 h-4"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        id="edit-alt"
                                    >
                                        <path
                                            fill={
                                                props.theme == 'dark'
                                                    ? '#FFFFFF'
                                                    : '#181818'
                                            }
                                            d="M5,18H9.24a1,1,0,0,0,.71-.29l6.92-6.93h0L19.71,8a1,1,0,0,0,0-1.42L15.47,2.29a1,1,0,0,0-1.42,0L11.23,5.12h0L4.29,12.05a1,1,0,0,0-.29.71V17A1,1,0,0,0,5,18ZM14.76,4.41l2.83,2.83L16.17,8.66,13.34,5.83ZM6,13.17l5.93-5.93,2.83,2.83L8.83,16H6ZM21,20H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z"
                                        ></path>
                                    </svg>
                                </button>
                            </HoverTooltip>
                        </div>
                        <div className="flex w-8 text-right items-center justify-center">
                            <HoverTooltip tooltipText="Удалить">
                                <button
                                    className=" flex w-6 h-6 rounded-full items-center justify-center hover:bg-[#ed9cae] dark:hover:bg-[#701f1f]"
                                    onClick={() =>
                                        props.onDeleteSupplierRow(rowKey)
                                    }
                                >
                                    <svg
                                        className="w-4 h-4"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        id="trash-alt"
                                    >
                                        <path
                                            fill={
                                                props.theme == 'dark'
                                                    ? '#FFFFFF'
                                                    : '#181818'
                                            }
                                            d="M10,18a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,10,18ZM20,6H16V5a3,3,0,0,0-3-3H11A3,3,0,0,0,8,5V6H4A1,1,0,0,0,4,8H5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V8h1a1,1,0,0,0,0-2ZM10,5a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1V6H10Zm7,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V8H17Zm-3-1a1,1,0,0,0,1-1V11a1,1,0,0,0-2,0v6A1,1,0,0,0,14,18Z"
                                        ></path>
                                    </svg>
                                </button>
                            </HoverTooltip>
                        </div>
                    </>
                )}
            </div>
            {contractSupplierEditPopup && (
                <ContractSupplierEditPopup
                    theme={props.theme}
                    contractSupplierGuid={props.contractSupplier.guid}
                    contractSupplier={props.contractSupplier}
                    handleContractSupplierEditPopup={
                        handleContractSupplierEditPopup
                    }
                    onSave={(patch) => {
                        props.onPatch(rowKey, patch)
                        handleContractSupplierEditPopup()
                    }}
                    oksmList={props.oksmList}
                    regionRfList={props.regionRfList}
                    contractAction={props.contractAction}
                    errors={props.errors}
                />
            )}
        </div>
    )
}

export default ContractSuppliersTableRow
